import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'start',
    paddingLeft: theme.spacing(2)
  },
  useApplicantAddressLabel: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start'
  },
  rentersInfoTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(2)
    }
  },
  rentersInfoText: {
    fontSize: '12px',
    color: theme.colorPalette.green_100
  },
  openSidesCheckbox: {
    minHeight: 66
  },
  bannerContainer: {
    '& > div': {
      textAlign: 'left'
    }
  },
  checkboxGridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  }
}));

export default useStyles;
